/* eslint-disable react-hooks/exhaustive-deps */
import AppButton from "components/AppButton/AppButton";

import { SecurityPageProps } from "models/security";
import { useEffect } from "react";
import { useHistory } from "react-router";
import { useAppDispatch } from "redux/app/hooks";
import {
  cleanStateCartao,
  setTelaBloqueio,
} from "redux/features/cartao/cartao-slice";
import { cleanStateUnlock } from "redux/features/cartao/desbloqueio-slice";
import { cleanState } from "redux/features/cliente/cliente-slice";
import {
  addPinPadAvailable,
  addTypeFlowState,
  cleanStatesecurity,
} from "redux/features/security/security-slice";
import { RouteNames } from "../../routes/routes";
import "./Home.css";
import { setLoading, setTitleLoading } from "redux/ui/loadings-slice";
import { getIP } from "hooks/getIPAddress";
import {
  LOCAL_STORE_CLIENTE,
  LOCAL_STORE_ITOKEN,
  LOCAL_STORE_THEME,
  LOCAL_STORE_THEME_IMAGE,
  LOCAL_STORE_TOKEN_BEARER,
} from "../../constants";
import useApi, { ApiMethod } from "hooks/useApi";
import Endpoints from "services/api/endpoints";
import { showMessage } from "utils/messages";

const Home = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();

  const GETStatusPinPadAdaga = useApi(
    Endpoints.pagamentosAdaga.getStatusPinPadAdaga,
    ApiMethod.GET
  );

  const POSTMakePaymentInvoiceAdaga = useApi(
    Endpoints.pagamentosAdaga.postMakePaymentInvoiceAdaga,
    ApiMethod.POST
  );

  const clickUnlock = () => {
    dispatch(setTelaBloqueio(true));
    dispatch(addTypeFlowState("desbloqueio"));
    const propsRouter: SecurityPageProps = {
      nextStep: RouteNames.SECURITY_CLIENTE_CPF,
      backStep: RouteNames.HOME,
      fluxoUnlock: true,
    };

    history.push({
      pathname: RouteNames.TERMO_E_CONDICOES,
      state: { ...propsRouter },
    });
  };
  const clickFatura = () => {
    dispatch(addTypeFlowState("fatura"));
    const propsRouter: SecurityPageProps = {
      title: "Tua Fatura",
      description: `<span>Por favor, digite <span>teu CPF</span> e pressione a tecla verde (ENTRA) para continuar a operação:</span>`,
      nextStep: RouteNames.SECURITY_CLIENTE_SENHA,
      backStep: RouteNames.HOME,
    };

    history.push({
      pathname: RouteNames.SECURITY_CLIENTE_CPF,
      state: { ...propsRouter },
    });
  };

  const clickAtendimento = () => {
    dispatch(addTypeFlowState("atendimento"));
    const propsRouter: SecurityPageProps = {
      title: "Teu Atendimento",
      description: `<span>Por favor, digite <span>teu CPF</span> e pressione a tecla verde (ENTRA) para continuar a operação:</span>`,
      nextStep: RouteNames.ATENDIMENTO_HOME,
      backStep: RouteNames.HOME,
    };

    history.push({
      pathname: RouteNames.SECURITY_CLIENTE_CPF,
      state: { ...propsRouter },
    });
  };

  const handleLimite = () => {
    dispatch(addTypeFlowState("limite"));
    const propsRouter: SecurityPageProps = {
      title: "Teu Limite",
      description: `<span>Por favor, digite <span>teu CPF</span> e pressione a tecla verde (ENTRA) para continuar a operação:</span>`,
      nextStep: RouteNames.SECURITY_CLIENTE_SENHA,
      backStep: RouteNames.HOME,
    };

    history.push({
      pathname: RouteNames.SECURITY_CLIENTE_CPF,
      state: { ...propsRouter },
    });
  };

  useEffect(() => {
    setTimeout(function () {
      dispatch(setLoading(false));
    }, 1000);
  }, []);

  useEffect(() => {
    localStorage.removeItem(LOCAL_STORE_ITOKEN);
    localStorage.removeItem(LOCAL_STORE_CLIENTE);
    localStorage.removeItem(LOCAL_STORE_TOKEN_BEARER);
    localStorage.removeItem(LOCAL_STORE_THEME_IMAGE);
    localStorage.removeItem(LOCAL_STORE_THEME);
    sessionStorage.clear();
    dispatch(cleanState());
    dispatch(cleanStateCartao());
    dispatch(cleanStateUnlock());
    dispatch(cleanStatesecurity());
    handlePinPadStatus();
  }, []);

  useEffect(() => {
    async function ip() {
      await getIP();
    }
    ip();
  }, []);

  const handlePinPadStatus = async () => {
    dispatch(setLoading(true));
    dispatch(setTitleLoading("Checando Pinpad..."));
    try {
      // GETStatusPinPadAdaga
      // Verifica o status da servidor e da pinpad.
      // Caso o servidor estiver fora retorna erro.
      // Caso o servidor estiver UP retorna um "status"
      // “status": "available | running_transaction | cancelling_transaction"
      const responseStatus = await GETStatusPinPadAdaga.callApi();

      if (responseStatus.status >= 200 && responseStatus.status <= 300) {
        const { status } = responseStatus?.data as any;
        if (status === "available") {
          handlePaymentAdaga();
        } else {
          dispatch(addPinPadAvailable(true));
          showMessage(
            "warning",
            "Atenção!",
            "Não houve comunicação com a maquininha de cartão (pinpad). Por favor, entre em contato com algum operador(a) da loja."
          );
          history.push(RouteNames.HOME);
          dispatch(setLoading(false));
        }
      } else {
        dispatch(addPinPadAvailable(true));
        showMessage(
          "warning",
          "Atenção!",
          "Não houve comunicação com a maquininha de cartão (pinpad). Por favor, entre em contato com algum operador(a) da loja."
        );
        history.push(RouteNames.HOME);
        dispatch(setLoading(false));
      }
    } catch (err) {
      console.log(err);
      dispatch(addPinPadAvailable(true));
      showMessage(
        "warning",
        "Atenção!",
        "Não houve comunicação com a maquininha de cartão (pinpad). Por favor, entre em contato com algum operador(a) da loja."
      );
      history.push(RouteNames.HOME);
      dispatch(setLoading(false));
    }
  };

  const handlePaymentAdaga = async () => {
    dispatch(setLoading(true));
    dispatch(setTitleLoading("Checando/Configurando Pinpad...."));

    try {
      const payload = {
        type: "debit-card", // credit-card ou debit-card
        amount: 10, // VALOR EM CENTAVOS
        service: "Vendas", // DEIXAR ESSE VALOR FIXO
        timeout: 2, // TIMEOUT DO PINPAD EM SEGUNDOS
        installments: 1, // QUANTIDADE DE PARCELA [OPCIONAL]
        entryAmount: null, // VALOR DE ENTRADA [OPCIONAL]
        externalId: "1234567890", // VALOR DO IDPAGAMENTO
        //   urlNotification: webhookPinpad, // URL DO WEBHOOK QUER SERA CHAMADO PARA INFORMAR O STATUS DO PAGAMENTO
      };
      const response = await POSTMakePaymentInvoiceAdaga.callApi(payload);

      if (response.status >= 200 && response.status <= 300) {
        dispatch(addPinPadAvailable(false));
      } else {
        dispatch(addPinPadAvailable(true));
      }
    } catch (err) {
      dispatch(addPinPadAvailable(true));
    } finally {
      dispatch(setLoading(false));
    }
  };

  return (
    <div className="page-content">
      <h1 id="home-title" className="page-title">
        TEUCARD
      </h1>

      <h3 className="page-subtitle">
        Mais vantagens, mais do teu jeito!
      </h3>

      <h4 id="home-second-subtitle">*Consulte nossa rede credenciada</h4>

      <div className="buttons-container">
        <div className="column-a">
          <AppButton content="Fatura" click={clickFatura} />
          <AppButton content="Limite" click={handleLimite} />

        </div>

        <div className="column-b">
          <AppButton content="Atendimento" click={clickAtendimento} />
          <AppButton content="Desbloqueio" click={clickUnlock} />
        </div>
      </div>
    </div>
  );
};

export default Home;
